import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuardService as AuthGuard } from '../auth/auth-guard.service';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { CreateMatchModule } from './create-match/create-match.module';
import { MatchesPage } from './matches.page';
import { TieMatchScoreboardModule } from '../ties/tie-details/tie-match-list/tie-match-scoreboard/tie-match-scoreboard.module';

const routes: Routes = [
    {
        path: '',
        component: MatchesPage,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        EmptyPageModule,
        CreateMatchModule,
        TranslateModule.forChild(),
        TieMatchScoreboardModule
    ],
    declarations: [
        MatchesPage    
    ]
})
export class MatchesPageModule { }
